import React, {Component, Fragment, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {Card, CF, E, FR, R} from "../_common/layout";
import {CompanyCompany} from "../_api";
import {
    fetchCompany,
    fetchCompanyOffersEmulation,
    fetchSchedules
} from "../_rx/jobs/actions";
import {Link} from "react-router-dom";
import {TabsCompany} from "./TabsCompany";
import CompanyCard from "./CompanyCard";
import Dropdown from "../_common/components/dropdown";
import {Helmet} from "react-helmet";
import Pagination from "../_common/components/pagination";
import {OFFERS_LIMIT_PAGES} from "../constants";

const youtubeEmbedUrl = (url: any)=>{
    const match = url.match(/\?v=([^&]+)/);
    if(!match) return "";
    return "https://www.youtube.com/embed/"+match[1]+"?rel=0&amp;modestbranding=1&amp;autohide=1&amp;mute=0&amp;showinfo=0&amp;controls=1"
}

type Props = {
    fetchCompany: typeof fetchCompany,
    fetchCompanyOffersEmulation: typeof fetchCompanyOffersEmulation,
    fetchSchedules: typeof fetchSchedules,
    company: CompanyCompany,
    history: any,
    match: any,
    companyOffersEmulation: any,
    schedules: any
};



class View extends Component<Props, {}> {

    state = {
        loading: false
    }

    componentDidMount() {
        // se fuerza siempre el cargado del company
        this.props.fetchCompany();
        this.props.fetchSchedules();
        this.updateOffers()
    }

    componentDidUpdate(previousProps: Readonly<Props>) {
        if (previousProps.match.params.page !== this.props.match.params.page){
            this.updateOffers()
        }
    }

    async updateOffers(){
        const page = (this.props.match.params.page ? this.props.match.params.page : 1)
        await this.props.fetchCompanyOffersEmulation({
            status: '1',
            limit: OFFERS_LIMIT_PAGES,
            page
        });
        this.setState({loading: false})
    }

    renderOffersNum = (offersNum: number) => {
        let text: string = '';

        if (offersNum === 0){
            text = t('No tienes ninguna oferta.')
        } else if (offersNum === 1){
            text = offersNum + " " + t("oferta")
        } else if (offersNum > 1){
            text = offersNum + " " + t("ofertas")
        }
        return text;
    }

    handleClick = () => {
        this.props.history.goBack();
    }

    handleChangePage = (page: number) => {
        const actualPage = parseInt(this.props.match.params.page)
        const isSamePage = (actualPage === page) || (isNaN(actualPage) && page === 1)
        if (isSamePage) return null
        
        this.props.history.push(`/company/preview/offers/${page}`)
        this.setState({loading: true})
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    render({company, companyOffersEmulation, schedules, history, match}: Props) {
        if(!company || !companyOffersEmulation || !schedules) return null;
        const isOffers = match.path.includes('offers');
        const page = parseInt((match.params.page === undefined) ? 1 : match.params.page)
        // return <pre>{JSON.stringify(company, null, '  ')}</pre>
        return <CF className="max-width-980">
            {(!company || (isOffers && !companyOffersEmulation)) ?
                <p className="t-center">
                    <em className="disabled-aspect-gray"> {t('Cargando')}. . . </em>
                </p> :
                <Fragment>
                    <Helmet>
                        <title>{company.name + ' | ILERNA'}</title>
                    </Helmet>
                    {this.props.history.length > 0 && <nav className="breadcrumb-wrapper p-x2-bottom">
                        <button onClick={this.handleClick} className="back breadcrumb-item without-background"><span className="font-16"><i className="fal fa-long-arrow-left" aria-hidden="true"></i> {t('Volver')}</span></button>
                    </nav>}

                    <FR className="flex-center-x d-none sm-d-flex">
                        <div className="sm-col-65">
                            <h1 className="no-margin m-bottom">{company.name}</h1>
                            {company.sector && <p>{company.sector}</p>}
                            {company.web && <Fragment><a href={company.web} target="_blank" className="url">{company.web}</a> | </Fragment>}
                            {company.location}
                            {company.empleados && ` | ${company.empleados} empleados`}

                        </div>
                        <div className="sm-col-35 d-flex flex-right flex-column">
                            <E className='flex-right d-flex'>
                                <Dropdown icon='fas fa-ellipsis-v' position='left-container' justIcon isGrey>
                                    <div className='dropdown-item'><Link to={'/company/edit'}>{t('Editar Perfil')}</Link></div>
                                </Dropdown>
                            </E>
                            <E className="flex-right d-flex">
                                {company.logo?
                                    <div className="card m-bottom image-squared-company" style={`background-image:url('${window.env.JOBS_API_basePath}/company/view-logo/${company.logo}');`} />:
                                    <div className="card m-bottom image-squared-company" />
                                }
                            </E>
                        </div>
                    </FR>
                    <FR className="sm-d-none d-flex">
                        <div className="col-100 d-flex flex-center-x">
                            {company.logo?
                                <div className="card m-bottom image-squared-company" style={`background-image:url('${window.env.JOBS_API_basePath}/company/view-logo/${company.logo}');`} />:
                                <div className="card m-bottom image-squared-company" />
                            }
                        </div>
                        <div className="col-100 d-flex flex-center-x">
                            <h1 className="no-margin">{company.name}</h1>
                        </div>
                        <div className="col-100 d-flex flex-center-x">
                            <span>{company.location} | {company.empleados} empleados</span>
                        </div>
                    </FR>
                    <TabsCompany match={match} />
                    {(!isOffers) ?
                        <Card smOnly={false}>
                            <div className="d-flex">
                                <p>{company.text}</p>
                            </div>
                            {company.video && <div className="youtube-responsive p-bottom">
                                <iframe className="embed-responsive-item" src={youtubeEmbedUrl(company.video)} frameBorder="0" allowFullScreen />
                            </div>}
                        </Card>
                        : <Fragment>
                            <FR>
                                <E>
                                    <span className="offer">
                                        {Array.isArray(companyOffersEmulation) && this.renderOffersNum(companyOffersEmulation.length)}
                                        {/*<Pagination pageMax={offers.pagination.totalPages} page={parseInt((match.params.page === undefined) ? 1 : match.params.page)} onClick={(page: number) => this.handlePageChanged(page)}/>*/}
                                    </span>
                                </E>
                            </FR>
                            <FR className='row-1-el'>
                                <E>
                                    <CompanyCard schedules={schedules} companyOffersEmulation={companyOffersEmulation.data} loading={this.state.loading}/>
                                </E>
                            </FR>
                            <div className='d-flex flex-center-x full-width'>
                                <Pagination
                                    pageMax={companyOffersEmulation.pagination.totalPages}
                                    page={page}
                                    onClick={(page:number) => this.handleChangePage(page)}
                                />
                            </div>
                        </Fragment>
                    }
                </Fragment>
            }
        </CF>
    }
}

const ConnectedView: any = connect(
    ({company, companyOffersEmulation, fixtures: {schedules}}: any)=>({company, companyOffersEmulation, schedules}), {fetchCompany, fetchCompanyOffersEmulation, fetchSchedules})(View as any);

export default ({history, match}: any) =>
    <AppPage
        name="company-preview"
        title=""
        subtitle=""
        className="max-width-980">
        <ConnectedView history={history} match={match} />
    </AppPage>
;

